import React, { useEffect, useRef, useState } from 'react'
import { formatDate } from '../../../utils/format.utils'
import { ChatBubbleOvalLeftIcon, CheckIcon, ChevronDownIcon, PencilIcon, PlusIcon, TrashIcon } from '@heroicons/react/24/outline'
import { CapsuleConfiguratorProvider } from '../../../context/CapsuleConfiguratorContext'
import CapsuleConfiguration from '../CapsuleConfiguration/CapsuleConfiguration'
import api from '../../../middleware/api'
import { useLocation, useNavigate, useOutletContext } from 'react-router-dom'
import { toast } from 'react-toastify'
import PortalModal from '../../Common/Modal/PortalModal'
import DrawerPortal from '../../Common/SidebarDrawer/DrawerPortal'


const UpdateCapsule = ({ capsule, configuration, selectedVersion, selectedConfigurationId, setSelectedVersion }) => {
    const nameInput = useRef(null)
    const [capsuleName, setCapsuleName] = useState(capsule.name)
    const [newConfigurationCreated, setNewConfigurationCreated] = useState(false)
    const [configurationComment, setConfigurationComment] = useState(capsule.configurations.find(c => c.id === selectedConfigurationId).information)
    const [isSavingName, setIsSavingName] = useState(false)
    const [isPreparingNewConfig, setIsPreparingNewConfig] = useState(false)
    const outletContext = useOutletContext()
    const deleteConfigurationModal = useRef(null)
    const drawerRef = useRef(null)
    const naviguate = useNavigate()
    const location = useLocation()

    const editCapsule = () => {
        setCapsuleName(nameInput.current.value)
    }

    const saveName = async (e) => {
        e && e.stopPropagation && e.stopPropagation();
        if (!capsuleName.trim()) {
            toast.info('Le nom de la capsule ne peut pas être vide');
            return;
        }
        setIsSavingName(true);
        try {
            const response = await api.put(`/capsules/update/name`, { id: capsule.id, name: capsuleName })
            if (response.status === 200) {
                outletContext.setData((prev) => {
                    return {
                        ...prev,
                        capsules: prev.capsules.map((c) => {
                            if (c.id === capsule.id) {
                                return { ...c, name: capsuleName }
                            }
                            return c
                        })
                    }
                })
                toast.success('Nom de la capsule mis à jour')
            } else {
                resetName()
                toast.error('Erreur lors de la mise à jour du nom')
            }
        } catch (err) {
            resetName()
            toast.error('Erreur lors de la mise à jour du nom')
        } finally {
            setIsSavingName(false);
        }
    }

    const resetName = () => {
        setCapsuleName(capsule.name)
    }

    const handleCreateNewConfig = async () => {
        try {
            const response = await api.post(`/capsules/configurations/create/default`, { capsuleId: capsule.id })
            outletContext.setData((prev) => {
                return {
                    ...prev,
                    capsules: prev.capsules.map((c) => {
                        if (c.id === capsule.id) {
                            console.log(response.data)
                            return { ...c, configurations: [...c.configurations, response.data] }
                        }
                        return c
                    })
                }
            });
            setNewConfigurationCreated(true)
            toast.success('Nouvelle validation créée')
        }
        catch (err) {
            console.error(err)
        }
    };

    const handleVersionChange = (event) => {
        setSelectedVersion(parseInt(event.target.value));
    };

    const showDeleteConfigurationModal = () => {
        if (deleteConfigurationModal.current) {
            deleteConfigurationModal.current.showModal()
        } else {
            console.warn('deleteConfigurationModal is not available')
        }
    }

    const hideDeleteConfigurationModal = () => {
        if (deleteConfigurationModal.current) {
            deleteConfigurationModal.current.hideModal()
        } else {
            console.warn('deleteConfigurationModal is not available')
        }
    }
    const handleDrawer = (e) => {
        e.stopPropagation()
        if (drawerRef.current) {
            drawerRef.current.showDrawer();
        }
    };

    const handleUpdateConfigurationInformation = async (e) => {
        try {

            const response = await api.patch(`/capsules/configurations/update/comment`, {
                configurationId: selectedConfigurationId,
                comment: configurationComment
            })
            if (response.status === 200) {
                outletContext.setData((prev) => {
                    return {
                        ...prev,
                        capsules: prev.capsules.map((c) => {
                            if (c.id === capsule.id) {
                                return {
                                    ...c,
                                    configurations: c.configurations.map((config) => {
                                        if (config.id === selectedConfigurationId) {
                                            return {
                                                ...config,
                                                information: configurationComment
                                            }
                                        }
                                        return config
                                    })
                                }
                            }
                            return c
                        })
                    }
                })
                toast.success('Information mise à jour')
                drawerRef.current.hideDrawer()
            }

        } catch (e) {
            console.error(e)
            toast.error('Erreur lors de la mise à jour')
        }
    }


    const handleDeleteConfiguration = async () => {
        try {
            const response = await api.delete(`/capsules/configurations/delete/${selectedConfigurationId}`)
            if (response.status === 200) {
                outletContext.setData((prev) => {
                    return {
                        ...prev,
                        capsules: prev.capsules.map((c) => {
                            if (c.id === capsule.id) {
                                console.log(c.configurations)
                                return {
                                    ...c,
                                    configurations: c.configurations.filter((config) => config.id !== response.data.configurationId)
                                }
                            }
                            return c
                        })
                    }
                })
                // Select last configuration (use -2 to match the current "capsule.configurations.length - 1" value)
                setSelectedVersion(capsule.configurations.length - 2)
                hideDeleteConfigurationModal()
                toast.success('Configuration supprimée')
            }
        } catch (error) {
            console.error(error)
            toast.error('Erreur lors de la suppression de la configuration')
        }
    }

    useEffect(() => {
        setCapsuleName(capsule.name)
    }, [capsule])


    useEffect(() => {
        if (newConfigurationCreated) {
            const newIndex = outletContext.capsules.find(c => c.id === capsule.id).configurations.length
            setSelectedVersion(newIndex - 1)
            setNewConfigurationCreated(false)
            // Fin de la préparation de la nouvelle configuration après sélection
            setIsPreparingNewConfig(false)
        }
    }, [newConfigurationCreated])

    useEffect(() => {
        setConfigurationComment(capsule.configurations.find(c => c.id === selectedConfigurationId).information)
    }, [selectedConfigurationId])
    useEffect(() => {
        if (location?.state && location?.state?.createNewConfig) {
            // Préparer la création de la première validation et masquer l'UI jusqu'à sélection
            setIsPreparingNewConfig(true)
            const run = async () => {
                try {
                    await handleCreateNewConfig()
                } finally {
                    // Utiliser replace pour éviter d'ajouter une nouvelle entrée dans l'historique
                    naviguate('.', { replace: true, state: { createNewConfig: false } });
                    // Si la création a échoué, on ré-affiche l'UI
                    setIsPreparingNewConfig(false)
                }
            }
            run()
        }
    }, [location.state])
    return (
        <div className="p-4 bg-white rounded-lg shadow-md">
            <div className='flex flex-col gap-8'>
                <div className="flex justify-between items-center ">
                    <div className='flex flex-row gap-2 items-center'>
                        <div tabIndex={0} className='   z-20 w-fit hover:pointer-events-auto rounded-xl flex input-bordered border border-solid border-base-300 text-xl h-fit max-w-xs p-1 focus-within:border-primary focus-within:ring-primary focus-within:outline-none' >
                            <p className="flex-shrink-0 text-lg self-center m-0 p-0 font-semibold h-fit">Capsule</p>
                            <input
                                ref={nameInput}
                                className='z-10 flex-shrink text-xl h-fit max-w-xs w-full py-1 rounded-xl border-none pl-4 focus:outline-none '
                                type="text"
                                value={capsuleName}
                                onChange={editCapsule}
                                disabled={isSavingName}
                                onBlur={async (e) => {
                                    // Si le nom a changé, on sauvegarde
                                    if (capsuleName !== capsule.name) {
                                        await saveName(e);
                                    }
                                }}
                            />
                        </div>
                        {isSavingName && (
                            <span className="ml-2 inline-flex align-end m-auto">
                                <span className="loading loading-spinner loading-primary bg-primary" ></span>
                            </span>
                        )}
                    </div>
                    <h3 className='m-auto text-2xl font-bold '>BILAN</h3>
                </div>

                <div className="flex flex-row w-full justify-between items-center">
                    <div className='flex flex-row justify-between items-center gap-2'>
                        <label>Configuration du</label>
                        <select
                            className="p-2 border border-gray-300 rounded"
                            value={selectedVersion}
                            onChange={handleVersionChange}
                        >
                            {capsule.configurations.map((config, index) => (
                                <option key={config.id} value={index}>
                                    {formatDate(config.creationDate)}
                                </option>
                            ))}
                        </select>
                        <div className="tooltip tooltip-top tooltip-primary" data-tip="Nouvelle validation">
                            <PlusIcon onClick={handleCreateNewConfig} className='w-6 h-6 text-gray-300 hover:text-primary transition-all cursor-pointer' />
                        </div>
                        <div className="tooltip tooltip-top tooltip-primary" data-tip="Commentaire de la configuration">
                            <ChatBubbleOvalLeftIcon onClick={handleDrawer} className='w-6 h-6 text-gray-300 hover:text-primary transition-all cursor-pointer' />
                        </div>
                        {selectedVersion !== 0 && configuration.content.length > 0 && (
                            <div className="tooltip tooltip-top tooltip-primary" data-tip="Supprimer la configuration">
                                <TrashIcon onClick={showDeleteConfigurationModal} className="h-6 w-6 text-gray-300 cursor-pointer" />
                            </div>
                        )}
                        <PortalModal ref={deleteConfigurationModal}>
                            <div className="p-4 gap-4 flex flex-col items-center">
                                <h1 className="text-lg font-bold">Supprimer la configuration</h1>
                                <p>Êtes-vous sûr de vouloir supprimer cette configuration ?</p>
                                <div className="flex gap-4">
                                    <button onClick={handleDeleteConfiguration} className="btn btn-primary">Supprimer</button>
                                    <button onClick={hideDeleteConfigurationModal} className="btn btn-error">Annuler</button>
                                </div>
                            </div>
                        </PortalModal>
                        <DrawerPortal ref={drawerRef}>
                            <div className="p-4 gap-4 flex flex-col items-center">
                                <textarea className="w-full min-h-40 h-fit border border-solid border-base-300 rounded p-2 resize-y" value={configurationComment || ''} onChange={(e) => setConfigurationComment(e.target.value)} />
                                <button onClick={handleUpdateConfigurationInformation} className="btn btn-primary">Enregistrer</button>
                            </div>
                        </DrawerPortal>
                    </div>
                    <div className="flex flex-wrap gap-4 text-sm">
                        <p className="badge badge-outline badge-primary gap-2">
                            Physique <span className='font-bold'>{(configuration.totalPhysique + configuration.totalOther) > 0 ? configuration.totalPhysique + configuration.totalOther : '-'}</span>
                        </p>
                        <p className="badge badge-outline badge-accent gap-2">
                            Effluences <span className='font-bold'> {configuration.totalEffluence > 0 ? configuration.totalEffluence : '-'}</span>
                        </p>
                    </div>
                </div>
            </div>
            <div className="border-t border-[#dedede] border-solid border-x-0 border-b-0 pt-4">
                {isPreparingNewConfig ? (
                    <div className="w-full py-12 flex items-center justify-center">
                        <span className="loading loading-spinner loading-primary bg-primary"></span>
                    </div>
                ) : (
                    <CapsuleConfiguratorProvider defaultCapsule={capsule} defaultConfig={configuration} selectedConfigurationId={selectedConfigurationId}>
                        <CapsuleConfiguration />
                    </CapsuleConfiguratorProvider>
                )}
            </div>
        </div>
    )
}

export default UpdateCapsule
